export const art70item = [

	{
		"xlsx": "/Transparencia/xlsx/a70_f01_f4Semarnath.xlsx",
		"tabla": "/Transparencia/htm/a70_f01_f4Semarnath.htm",
	}
]